import React, { Fragment } from 'react'
import { Text } from '@chakra-ui/react'
import { Outlet } from 'react-router-dom'
function Flows() {
    return (
        <Fragment>
            <Outlet></Outlet>
        </Fragment>
    )
}

export default Flows
